import ko from 'rgs-knockout';

import { YandexSmartCaptchaInvisibleModel } from './js/model';
import template from './templates/template.html';

ko.components.register('yandex-smart-captcha-invisible', {
	viewModel: YandexSmartCaptchaInvisibleModel,
	template: template(),
});